import React, { useState, useEffect, useRef, Fragment } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { startSetEditProfile, startSetProfile } from '../../actions/webmaster';
import ThemeChooserItem from './ThemeChooserItem';
import Icon from '../../components/Icon/Icon';

const propTypes = {
  startSetEditProfile: func.isRequired,
};

const defaultProps = {
  startSetEditProfile: function() {},
};

const ThemeChooserWidget = ({ startSetEditProfile, startSetProfile, profile }) => {
  const [open, setOpenState] = useState(false);
  const [theme, setTheme] = useState(0);
  const [loading, setLoadingState] = useState(false);

  const submitButton = useRef(null);

  const onThemeChange = e => {
    const { value } = e.target;
    setTheme(value);
  };

  const isThemeChosen = () => {
    return theme !== 0;
  };

  const onSubmit = () => {
    setLoadingState(true);
    window.hasChosenTheme = true;

    startSetEditProfile({
      ...profile,
      theme,
    }).then(() =>
      startSetProfile().then(() => {
        setLoadingState(false);
        setOpenState(false);
      }),
    );
  };

  const onWidgetClose = () => {
    setTheme(1);
    onSubmit();
  };

  useEffect(() => {
    setTimeout(setOpenState, 2000, true);
  }, []);

  useEffect(() => {
    const elem = submitButton.current;
    elem && elem.scrollIntoView({ behavior: 'smooth' });
  }, [theme]);

  return (
    <Fragment>
      <div
        className={
          open ? `theme-chooser theme-chooser--open` : `theme-chooser theme-chooser--closed`
        }
      >
        <Icon type="cross" onClick={onWidgetClose} />

        <div className="theme_chooser-controls">
          <h3 className="theme-chooser-title">
            <FormattedHTMLMessage
              tagName="span"
              id="theme_chooser.title"
              defaultMessage="Select UI&nbsp;theme"
            />
          </h3>

          <div className="theme-chooser-themes">
            <ThemeChooserItem theme="1" checkedTheme={theme} onThemeChange={onThemeChange}>
              <FormattedMessage id="theme_chooser.themes.new" defaultMessage="Ligh theme" />
              <span className="theme-chooser-addition">
                {' '}
                <FormattedHTMLMessage
                  tagName="span"
                  id="theme_chooser.themes.new.addition"
                  defaultMessage="(default)"
                />
              </span>
            </ThemeChooserItem>

            <ThemeChooserItem theme="2" checkedTheme={theme} onThemeChange={onThemeChange}>
              <FormattedMessage id="theme_chooser.themes.classic" defaultMessage="Dark theme" />
            </ThemeChooserItem>
          </div>
          {isThemeChosen() && (
            <div className="time-chooser-submit">
              <button
                className={`btn theme-chooser-submit-btn theme-${theme}`}
                onClick={onSubmit}
                ref={submitButton}
                disabled={loading}
              >
                <FormattedMessage id="theme_chooser.start" defaultMessage="Get started" />
              </button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

ThemeChooserWidget.propTypes = propTypes;
ThemeChooserWidget.defaultProps = defaultProps;

const mapDispatchToProps = dispatch => ({
  startSetProfile: () => dispatch(startSetProfile()),
  startSetEditProfile: data => dispatch(startSetEditProfile(data)),
});

const mapStateToProps = state => ({
  profile: state.webmaster.profile,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThemeChooserWidget);
